// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.161Z

export const heroes = [
  {
    "id": "syn_bishor",
    "name_ru": "«Мясник» Бишор",
    "name_en": "Bishor the Butcher",
    "faction": "syntetics",
    "type": "hero",
    "rarity": "special",
    "archetype": "Гладиатор Героем",
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 14,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1 раз за матч: -1 hp Герою Бишору, выбранный союзный юнит получает +3/0/1 до конца игры. Урон Герою от активки идёт всегда (Сквилл/Раст-переопределения сюда не относятся, это активка Героя, не Модификация).",
      "trigger": "Триггер «когда любой союзник получает Мод»: Герой Бишор +1/0/0 до конца игры."
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_received_mod",
      "filter": "any",
      "target": "hero_self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "ally_choose",
      "effect": "composite",
      "value": "damage:1@hero_self|buff_perm:3/0/1@ally_choose",
      "duration": "permanent",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Под комбинезоном — больше железа, чем мяса. Ни одно зеркало давно не показывает Бишора целиком — только части.",
    "ability_text_en": {
      "active": "Once per match: -1 hp to Hero Bishor; a chosen allied unit gets +3/0/1 for the rest of the game. The Hero damage from this active always applies (Skwill/Rust overrides don't count here — this is a Hero active, not a Modification).",
      "trigger": "Trigger «when any ally gains a Mod»: Hero Bishor +1/0/0 for the rest of the game."
    }
  },
  {
    "id": "syn_rast",
    "name_ru": "«Грязный тактик» Раст",
    "name_en": "Rast the Dirty Tactician",
    "faction": "syntetics",
    "type": "hero",
    "rarity": "special",
    "archetype": "Орда мутантов",
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 11,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1 раз за матч: скопируй любой Мод с одного твоего союзника на другого твоего союзника (исходный Мод остаётся на источнике, на цели появляется копия).",
      "trigger": "Пассивка: каждому твоему новому юниту при выставлении на стол выдаётся 1 случайный Мод (генерация, бесплатно, без урона Герою). Только 1 Мод, не накапливается."
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_summoned",
      "filter": "any",
      "target": "ally_summoned",
      "effect": "attach_random_mod",
      "value": "1",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "ally_choose",
      "effect": "copy_mod_between_allies",
      "value": "1",
      "duration": "oneshot",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Раст не делит свою банду на людей и не-людей. Все, кто попал к нему — уже не люди.",
    "ability_text_en": {
      "active": "Once per match: copy any Mod from one of your allies onto another ally (the original Mod stays on the source; a copy appears on the target).",
      "trigger": "Passive: each of your new units, when deployed, gains 1 random Mod (generated, free, no Hero damage). Only 1 Mod, doesn't stack."
    }
  },
  {
    "id": "syn_skvill",
    "name_ru": "«Умняк» Сквилл",
    "name_en": "Squill the Brain",
    "faction": "syntetics",
    "type": "hero",
    "rarity": "special",
    "archetype": "Безболезненный спам",
    "exclusive_hero": null,
    "atk": 2,
    "armor": 1,
    "hp": 12,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1 раз за матч: вражеский юнит атакует своего ближайшего союзного юнита (выбирает игрок Сквилла из юнитов противника).",
      "trigger": "Пассивка: вторая карта за ход (Модификация в Ф2 в дополнение к юниту/Действию) не наносит урон Герою. Стартовая рука включает 2 случайных Мода фракции в дополнение к стандартной раздаче."
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "match_start",
      "filter": "self",
      "target": "self",
      "effect": "no_self_damage_on_second_card_played_per_turn",
      "value": "+2_random_mods_to_starting_hand",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "enemy_choose",
      "effect": "mind_control_attack_own_ally",
      "value": "1",
      "duration": "oneshot",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Сквилл собирает себе не друзей, а лабораторных мышей. Только некоторые из них стреляют.",
    "ability_text_en": {
      "active": "Once per match: an enemy unit attacks its nearest allied unit (Skwill's player picks which enemy unit).",
      "trigger": "Passive: a second card per turn (a Modification in Phase 2 in addition to a unit/Action) deals no Hero damage. Starting hand includes 2 random faction Mods on top of the standard draw."
    }
  },
  {
    "id": "syn_uein",
    "name_ru": "Рипер Уэйн",
    "name_en": "Reaper Wayne",
    "faction": "syntetics",
    "type": "hero",
    "rarity": "special",
    "archetype": "Sacrifice-кастер",
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 13,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1 раз за матч: уничтожь своего юнита на поле, нанеси его атаку Герою врага (игнорирует Авангард). Атака берётся текущая (с учётом Модов и баффов).",
      "trigger": "Триггер «начало каждого хода»: добавь 1 случайный Мод в руку (генерация, не из колоды)."
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "self",
      "effect": "generate_mod_to_hand",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "ally_choose",
      "effect": "destroy_self_then_damage_hero",
      "value": "target_atk",
      "duration": "oneshot",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Уэйн не бьёт сам. Он смотрит, как умирают его люди, и за каждой смертью прячется удар, который он наконец нанесёт.",
    "ability_text_en": {
      "active": "Once per match: destroy one of your units on the field and deal its attack to the enemy Hero (ignores Taunt). Uses the current attack (including Mods and buffs).",
      "trigger": "Trigger «start of each turn»: add 1 random Mod to your hand (generated, not from the deck)."
    }
  }
];
